module.exports = __webpack_public_path__ + "assets/img/user2.2a3c944e.png";